import { REACT_APP_ENV } from "./environments";

export const countriesAttributes = [
  {
    name: "Argentina",
    code: "AR",
    mp_app_id:
      REACT_APP_ENV === "production" ? "5209291587052639" : "3101358980026147",
  },
  {
    name: "Brasil",
    code: "BR",
    mp_app_id:
      REACT_APP_ENV === "production" ? "3792830753038899" : "7829976011795699",
  },
  {
    name: "Chile",
    code: "CL",
    mp_app_id:
      REACT_APP_ENV === "production" ? "4856585933658827" : "4454184800284490",
  },
  {
    name: "Colombia",
    code: "CO",
    mp_app_id:
      REACT_APP_ENV === "production" ? "5170287918334279" : "8779865090787194",
  },
  {
    name: "Mexico",
    code: "MX",
    mp_app_id:
      REACT_APP_ENV === "production" ? "6072306578948971" : "6072306578948971",
  },
  {
    name: "Peru",
    code: "PE",
    mp_app_id:
      REACT_APP_ENV === "production" ? "1074762883868449" : "8701876196122450",
  },
  {
    name: "Uruguay",
    code: "UY",
    mp_app_id:
      REACT_APP_ENV === "production" ? "6694409942434251" : "5081050897460870",
  },
];
